import * as log from 'loglevel';
import * as _ from "lodash"
import * as ko from 'knockout';
import {ComputedOptions} from "~knockout/index";
import {getSecondaryScreenVisibilityOptions} from "../../ScreenVisibility";
import {Screen} from "../../Screen";
import {hideSecondaryScreens, showPrimaryScreen, showSecondaryScreen} from "../../ScreenManager";
import {getGameManager} from "../../../game/GameManager";
import {Observable} from '~knockout/index';
import {ObservableArray} from '~knockout/index';
import {questionData} from '../../../data/Questions';
import {startUsingNewTileset} from "../../../game/level/backgrounds/Backgrounds";
import {gameState} from "../../../game/config/GameState";
import {queuePowerUp} from "../../../game/level/power-ups/PowerUps";
import {startStage} from '../../../game/level/stages/StageManager';
import {gameConfig} from '../../../game/config/GameConfig';
import {resetObstacles} from '../../../game/level/ground/Obstacles';
import {hideSign, resetPlayerOutro} from '../../../game/sprites/player/Player';
import {allowPlatforms} from '../../../game/level/platforms/Platforms';
import {playSound} from '../../../game/audio/AudioManager';
import {getDifficultyLevel} from "../../main-menu/difficulty-select/DifficultySelectScreen";
import {playUiVoiceover} from "../../../audio/voiceovers/VoiceOverManager";
import {transitionIn, transitionOut} from '../../transition-overlay/TransitionOverlay';
import {resetRecyclingPickups} from "../../../game/level/platforms/RecyclingPickups";

interface IQuestionGroup
{
    difficulty: number;
    questions: IQuestion[];
}
interface IQuestion
{
    question: string;
    options: IAnswer[];
    response: string;
    sfxID: string;
}
interface IAnswer
{
    label: string;
    response: string;
    correct?: boolean;
    sfxID: string;
}

var template = require('./QuestionOverlayComponent.html');


class GameplayQuestionOverlayComponent extends Screen
{
    state: Observable<string>;
    question: IQuestion;
    questionIndex: number;
    questionText: Observable<string>;
    answers: ObservableArray<IAnswer>;
    selectedAnswer: IAnswer;
    selectedAnswerIndex: Observable<number>;
    responseLabel: Observable<string>;
    responseText: Observable<string>;

    unaskedQuestions: number[];
    questionStage: number;

    /**
     * get screen visibility computed options
     * @returns {ComputedOptions<boolean>}
     */
    getVisibleOptions() : ComputedOptions<boolean>
    {
        return getSecondaryScreenVisibilityOptions('gameplay', 'question');
    }


    /**
     * create knockout bindings
     */
    createBindings()
    {
        super.createBindings();

        this.state = ko.observable();
        this.questionText = ko.observable();
        this.answers = ko.observableArray();
        this.selectedAnswerIndex = ko.observable(null);
        this.responseLabel = ko.observable();
        this.responseText = ko.observable();

        this.questionStage = 1;
    }


    /**
     * when we show the game screen, start the game
     */
    onShow()
    {
        //  set the overlay state

        this.state('question');

        var timeline: TimelineMax;

        timeline = new TimelineMax();

        timeline.fromTo('.pp-gameplay-question', 0.5, { opacity: 0 }, { opacity: 1, ease: Expo.easeOut });
        timeline.fromTo('.pp-gameplay-question__modal--question', 1, { top: '-300%' }, { top: '50%', ease: Back.easeOut, easeParams: [0.8] }, 0.5);

        //  get the question to ask

        this.question = this.getQuestion();
        this.selectedAnswerIndex(null);

        //  show the question

        this.askQuestion(this.question);

        playUiVoiceover('questions--intro');

        transitionOut();
    }


    /**
     * get a question object from the data
     */
    getQuestion() : IQuestion
    {
        var questionIndex: number,
            questionsForDifficulty: IQuestion[];

        //  get the list of questions for the current difficulty level

        questionsForDifficulty = this.getQuestionsForDifficulty();

        //  if no array of unasked questions exists, create one now

        if ( ! this.unaskedQuestions || this.unaskedQuestions.length === 0)
        {
            this.unaskedQuestions = _.times(questionsForDifficulty.length, i => i);

            this.unaskedQuestions = _.shuffle(this.unaskedQuestions);
        }

        //  pull and random index from the array of unasked questions

        this.questionIndex = questionIndex = this.unaskedQuestions.shift();

        //  play question VO

        setTimeout(() => playUiVoiceover('question' + (questionIndex + 1) + '--' + (getDifficultyLevel() === 1 ? 'medium' : 'hard')), 4000);

        //  use that question

        return <IQuestion>questionsForDifficulty[questionIndex];
    }


    /**
     * get the list of questions for the current difficulty
     * @return {IQuestion[]}
     */
    getQuestionsForDifficulty() : IQuestion[]
    {
        let questionGroup: IQuestionGroup;

        questionGroup = <IQuestionGroup>_.find(questionData, { difficulty: getDifficultyLevel() });

        return questionGroup.questions;
    }


    /**
     * show the overlay and pose a question
     */
    askQuestion(questionObj: IQuestion)
    {
        this.questionText(questionObj.question);
        this.answers(questionObj.options);
    }


    /**
     * highlight the question and play its voiceover
     */
    highlightQuestion()
    {
        playUiVoiceover(this.question.sfxID);
    }


    /**
     * highlight an answer and play its voiceover
     */
    highlightAnswer = (answer: IAnswer) =>
    {
        // playUiVoiceover(answer.)
    };


    /**
     * get the VO id for an answer
     * @param index
     */
    getAnswerVO(index: number) : string
    {
        return 'question' + (this.questionIndex + 1) + '--' + (getDifficultyLevel() === 1 ? 'medium' : 'hard') + '-answer-' + (index + 1);
    }


    /**
     * when the user selects an answer, highlight it
     * @param answer
     * @param $index
     */
    selectAnswer = (answer: IAnswer, $index: number) =>
    {
        //  save the selected answer and its index

        this.selectedAnswerIndex($index);

        this.selectedAnswer = answer;

        //playUiVoiceover('question' + (this.questionIndex + 1) + '--' + (getDifficultyLevel() === 1 ? 'medium' : 'hard') + '-answer-' + ($index + 1));
    };


    /**
     * confirm the chosen answer
     */
    confirmAnswer = () =>
    {
        //  choose the correct answer

        var correctAnswer: IAnswer = <IAnswer>_.find(this.question.options, <any>'correct');

        //  set the answer title and response

        this.responseLabel(correctAnswer.label);
        this.responseText(this.question.response);

        //  check whether the chosen answer is correct

        this.selectedAnswer.correct === true ? this.answerIsCorrect() : this.answerIsIncorrect();
    };


    /**
     * the answer is correct! huzzah!
     */
    answerIsCorrect()
    {
        //  set the overlay state

        this.state('correct');

        //  if the answer is correct, award the user some bonus time

        getGameManager().incrementTimeRemaining(gameConfig.game.questionBonusTime);

        //  display power-up effect to the user

        getGameManager().visibleBonus('+' + gameConfig.game.questionBonusTime + ' seconds');

        //  play sound

        playSound('correct-answer');

        playUiVoiceover('questions--correct-' + _.random(0, 2), 1000);
    }


    /**
     * incorrect answer: BOO.
     */
    answerIsIncorrect()
    {
        //  set the overlay state

        this.state('incorrect');

        //  play sound

        playSound('incorrect-answer');

        playUiVoiceover('questions--incorrect-' + _.random(0, 2), 1000);

    }


    /**
     * continue with the game
     */
    continueGame()
    {
        //var timeline: TimelineMax;
        //
        //timeline = new TimelineMax({ onComplete: () => continueGameAfterQuestion()});
        //
        //timeline.to('.pp-gameplay-question__modal--question', 1, { top: '-20%', ease: Back.easeOut, easeParams: [0.8] });
        //timeline.to('.pp-gameplay-question', 0.5, { opacity: 0, ease: Expo.easeOut }, 0.25);

        //  play a button sound

        playSound('button-click');

        //  continue the game

        continueGameAfterQuestion()
    };
}


/**
 * when the question round is over, let's continue the game
 */
export function continueGameAfterQuestion()
{
    //  start counting the score again

    //  we're not longer outside

    gameState.level.isOutside = false;

    //  queue the next tileset

    startUsingNewTileset();

    //  resume creating platforms and power-ups

    transitionIn();

    // generatePlatform();

    resetRecyclingPickups();

    hideSign();
    setTimeout(() => showSecondaryScreen('level-intro'), 1000);
    setTimeout(() => transitionOut(), 1500);
    setTimeout(() => startStage(), 3000);

    resetPlayerOutro();

    //  restore control

}


/**
 * register this component with knockout
 */
export function registerGameplayQuestionOverlayComponent()
{
    ko.components.register('pp-gameplay-question-overlay',
        {
            viewModel: () => { return new GameplayQuestionOverlayComponent() },
            template: template
        });
}


// WEBPACK FOOTER //
// ./src/ts/screens/gameplay/questions/QuestionOverlayComponent.ts